<template>
  <ModuleSection title="交易明细查询" class="transaction-detail-page">
    <!-- 查询表单 -->
    <el-form
      ref="queryForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      class="transaction-detail-query"
    >
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('账号')"
            prop="accountNo"
          >
            <el-select
              v-model="formData.accountNo"
              @change="changeAccount"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option
                v-for="(value, key) in accountMap"
                :key="key"
                :label="value | translateFilter"
                :value="key" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('币种')"
            prop="currencyShowName"
          >
            <el-input :value="$t(formData.currencyShowName)" type="text" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('查询类型')"
            prop="loanFlag">
            <el-select
              v-model="formData.loanFlag"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option
                v-for="(key, value) in queryType"
                :key="value"
                :label="$t(key)"
                :value="value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('快捷查询期限')"
            prop="timeLimit">
            <el-radio-group v-model="formData.timeLimit" @change="changeTimeLimit">
              <el-radio label="1">{{ $t('一周') }}</el-radio>
              <el-radio label="2">{{ $t('一个月') }}</el-radio>
              <el-radio label="3">{{ $t('三个月') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('开始日期')"
            prop="startDate"
          >
            <el-date-picker
              v-model="formData.startDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('结束日期')"
            prop="endDate"
          >
            <el-date-picker
              v-model="formData.endDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
      </el-row>
      <span class="search-tip">{{ $t('注：查询使用的日期是交易提交日期') }}</span>
    </el-form>
    <!-- 查询按钮 -->
    <el-row style="margin: 20px 0 40px;">
      <el-button class="btn140" type="primary" @click.stop="getTableData">{{ $t('查询') }}</el-button>
      <el-button class="btn140" type="primary" @click="batchDownload">{{ $t('批量下载电子回单') }}</el-button>
      <el-button class="btn140" type="info" @click="resetQuery">{{ $t('重置') }}</el-button>
    </el-row>
    <DataTable
      :data="tableData"
      :loading="tableLoading">
      <el-table-column
        :label="$t('提交日期')"
        prop="transactionDate"
        min-width="120">
        <template slot-scope="scope">
          {{ $_format.dataToDay(scope.row.transactionDate) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('完成日期')"
        prop="dealTime"
        min-width="120">
        <template slot-scope="scope">
          {{ $_format.dataToDay(scope.row.dealTime) }}
        </template>
       </el-table-column>
      <el-table-column
        :label="$t('交易类型')"
        prop="TXMMO"
        min-width="120">
        <template slot-scope="scope">
          {{ $t($_params.GRB_TRANSFER_TYPE[scope.row.TXMMO]) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('交易金额')"
        prop="transAmount"
        min-width="120">
      </el-table-column>
      <el-table-column
        :label="$t('交易渠道')"
        min-width="120">
        <template slot-scope="scope">
          <p>{{ $t($_params.GRB_TRANSFER_CHANNEL[scope.row.TXCHNL]) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('余额')"
        min-width="150"
        prop="balance">
      </el-table-column>
      <el-table-column
        v-if="formData.loanFlag === 'A'"
        :label="$t('币种')"
        min-width="120"
        prop="purpose">
        <template slot-scope="scope">
          <p>{{ $t($_params.GRB_CURRENCY_TYPE[scope.row.currencyType]) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('摘要')"
        min-width="160"
        prop="narrative">
      </el-table-column>
      <el-table-column
        :label="$t('交易状态')"
        prop="status"
        min-width="140">
        <template slot-scope="scope">
          <p>{{ $t($_params.ORDER_STATUS[scope.row.status]) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('电子回单')"
        min-width="175">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.receiptNo"
            type="primary"
            :underline="false"
            @click="handleViewDetail(scope.row)">
            {{ $t('查看') }}
          </el-link>
          <el-link
            v-if="scope.row.receiptNo"
            type="primary"
            :underline="false"
            @click="download(scope.row)">
            {{ $t('下载') }}
          </el-link>
        </template>
      </el-table-column>
    </DataTable>
    <!-- 分页 -->
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      :total="total"
      layout="prev, pager, next, jumper" />
    <!-- 电子回单查看弹窗 -->
    <ElectronicReceipt
      v-if="electronicReceiptVisble"
      :detail="electronicReceiptDteail"
      :visible="electronicReceiptVisble"
      @cancel="electronicReceiptVisble = false"
    />

    <!-- 电子回单批量下载弹窗 -->
    <DownloadElectronicReceiptDialog
      v-if="visible"
      :visible="visible"
      :searchFormData="formData"
      @cancel="visible = false"
    />

    <!-- 电子回单下载确认 -->
    <el-dialog
      :title="$t('选择下载版本')"
      :visible.sync="confirmDownloadVisible"
      @close="confirmDownloadVisible = false"
      width="720px"
    >
      <el-form
        ref="downloadForm"
        :model="downloadFormData"
        label-position="left"
      >
        <el-form-item
          :label="$t('版本')"
          prop="downloadVersion">
          <el-radio-group v-model="downloadFormData.downloadVersion">
            <el-radio label="EN_CN">{{ $t('中英文') }}</el-radio>
            <el-radio label="EN">{{ $t('English') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="payee-list-filter-btns" style="display: flex; justify-content: flex-end;">
        <el-button class="search" type="primary" @click="confirmSingleDownload">{{ $t('确定') }}</el-button>
        <el-button class="reset" @click="confirmDownloadVisible = false">{{ $t('取消') }}</el-button>
      </div>
    </el-dialog>
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import ElectronicReceipt from '../../components/ElectronicReceipt'
import DownloadElectronicReceiptDialog from '../../components/DownloadElectronicReceiptDialog'
import { downloadBlob } from '@/utils/utils'
import transactionDetailApi from '../../api/transactionDetailApi'

export default {
  name: 'TransactionDetailCache',
  components: {
    ModuleSection,
    DownloadElectronicReceiptDialog,
    ElectronicReceipt
  },
  data () {
    return {
      /* 查询表单 */
      accountMap: {},
      formData: {
        accountNo: '', // 账户
        accountNoShow: '',
        loanFlag: 'A', // 账户类型
        currencyType: '', // 币种
        currencyShowName: '', // 币种展示
        startDate: '', // 开始日
        endDate: '', // 结束日
        timeLimit: '1' // 选择查询期限
      },
      transType: {
        'INWARD REMITTANCE': '汇入汇款',
        'REVERSAL INWARD REMITTANCE': '汇入冲销',
        'INWARD REMITTANCE FEE': '汇入手续费',
        'REVERSAL INWARD REMITTANCE FEE': '汇入手续费冲销',
        'OUTWARD REMITTANCE': '汇出汇款',
        'REVERSAL OUTWARD REMITTANCE': '汇出冲销',
        'OUTWARD REMITTANCE FEE': '汇出手续费',
        'REVERSAL OUTWARD REMITTANCE FEE': '汇出手续费冲销',
        'TRANSFER OUT': '下挂账号 & 行内转账转出',
        'TRANSFER IN': '下挂账号 & 行内转账入金',
        'TRANSFER FEE': '行内转账费用',
        ACOPF: '开户费',
        USBKF: 'U盾费用',
        ACSVF: '企业账户管理费',
        CERTF: '网银证书年费',
        INWRF: '入账手续费',
        OUTWF: '转账手续费'
      },
      // 查询类型
      queryType: {},
      /* 查询表格 */
      tableData: [],
      tableLoading: false,
      /* 分页 */
      pageNum: 1,
      pageSize: 10,
      total: 0,

      visible: false, // 电子回单弹窗
      confirmDownloadVisible: false, // 电子回单下载弹窗
      currentItem: {}, // 当前操作的列表项
      downloadFormData: {
        downloadVersion: 'EN_CN'
      },

      electronicReceiptDteail: {}, // 电子回单详情
      electronicReceiptVisble: false // 电子回单详情弹窗
    }
  },
  activated () {
    this.init()
  },
  computed: {
    rules () {
      return {
        accountNo: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        currencyShowName: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        startDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        endDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init () {
      // 获取账户列表
      this.accountMap = this.$_params.getSessionAccountSelect_obj_includeBC('ALL', true, 0, 0) || {}
      // 如果从其他页面带着参数，则去匹配筛选帐号
      const query = this.$route.query
      let flag = false
      if (query.accountNo && (query.currency || query.currencyType)) {
        Object.keys(this.accountMap).forEach(key => {
          if (key.split('|')[0] === query.accountNo && key.split('|')[1] === (query.currency || query.currencyType)) {
            this.formData.accountNo = key
            flag = true
          }
        })
      }
      if (!flag) this.formData.accountNo = Object.keys(this.accountMap)[0]
      this.formData.accountNoShow = this.accountMap[this.formData.accountNo]
      this.formData.currencyType = this.formData.accountNo.split('|')[1]
      this.formData.currencyShowName = this.$t(this.$_params.getCurrencyType(this.formData.accountNo.split('|')[0]))
      // 查询类型
      this.queryType = this.$_params.GRB_QUERY_TYPE
      // 计算时间默认展示范围
      this.formData.endDate = this.$_format.getToday()
      // this.formData.endDate = '2020-03-01'
      this.formData.startDate = this.$_format.getLastDay(this.formData.endDate, 7)
      this.getTableData()
    },
    // 查看电子回单详情
    handleViewDetail (item) {
      transactionDetailApi.ereceiptDetail({
        receiptNo: item.receiptNo
      }).then(res => {
        if (res) {
          res.paymentAmount = this.$_format.toCashWithComma(res.paymentAmount) + ' ' + res.paymentCurrency

          if (res.receiptType === '2') {
            res.transType = this.transType[res.transType] || res.transType || '--'
          }
          this.electronicReceiptDteail = {
            ...res,
            receiptNo: item.receiptNo
          }
          this.electronicReceiptVisble = true
        }
      }).catch(error => {
        console.error(error)
      })
    },
    // 单个下载确认
    confirmSingleDownload () {
      const { receiptNo } = this.currentItem
      transactionDetailApi.downloadEreceipt({
        receiptNo,
        languageType: this.downloadFormData.downloadVersion
      }).then(res => {
        if (res) {
          // 还没有搞明白这个filename的生成规则
          const filename = this.$i18n.locale === 'zh-CN' ? `CBiBank电子回单_${receiptNo}_汇出` : `CBiBank_${this.$t('电子回单')}_${receiptNo}_${this.$t('汇出')}`
          downloadBlob(res, {
            filename,
            ext: 'pdf'
          })
          this.$success('下载成功')
          this.confirmDownloadVisible = false
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 下载电子回单
    download (item) {
      this.currentItem = item
      this.confirmDownloadVisible = true
    },
    // 批量下载
    batchDownload () {
      // 判断是否在一年之内（365天）
      const { startDate, endDate } = this.formData
      const flag = this.$_format.checkDate(startDate, endDate)

      if (flag !== true) {
        this.$warn(flag)
        return false
      }
      this.visible = true
    },
    // 更换账户
    changeAccount (e) {
      this.formData.currencyType = e.split('|')[1]
      this.formData.accountNoShow = this.accountMap[this.formData.accountNo]
      this.formData.currencyShowName = this.$t(this.$_params.getCurrencyType(e.split('|')[0]))
    },
    // 修改查询期限
    changeTimeLimit (e) {
      if (e === '1') {
        this.formData.startDate = this.$_format.getLastDay(this.formData.endDate, 7)
      } else if (e === '2') {
        this.formData.startDate = this.$_format.getLastDay(this.formData.endDate, 30)
      } else if (e === '3') {
        this.formData.startDate = this.$_format.getLastDay(this.formData.endDate, 90)
      }
    },
    /* 表单按钮 */
    // 查询
    getTableData () {
      const { formData, pageNum, pageSize } = this

      const startDate = this.formData.startDate.split('-').join('')
      const endDate = this.formData.endDate.split('-').join('')
      // 判断是否在一年之内（365天）
      const flag = this.$_format.checkDate(this.formData.startDate, this.formData.endDate)
      if (flag !== true) {
        this.$warn(flag)
        return false
      }
      this.tableLoading = true

      return transactionDetailApi.getTableData({
        ...formData,
        startDate,
        endDate,
        accountNo: formData.accountNo.split('|')[0],
        pageNum,
        pageSize,
        logRecordFlag: '1',
        currentBusinessCode: '10100100'
      }).then(res => {
        this.tableLoading = false
        if (res) {
          const { list, totalSize } = res
          this.tableData = list || []
          this.total = totalSize
        }
      }).catch(err => {
        this.tableLoading = false
        console.error(err)
      })
    },
    // 重置
    resetQuery () {
      this.$refs.queryForm.resetFields()
      this.init()
    },
    handleQuery () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.pageNum = 1
          this.getTableData()
        }
      })
    },
    /* 分页 */
    handleSizeChange () {
      this.getTableData()
    },
    handleCurrentChange () {
      this.getTableData()
    }
  }
}
</script>

<style lang="less">
.transaction-detail-page {
  .search-tip {
    font-size: 14px;
    font-weight: 300;
    color: #a1a7c4;
    line-height: 14px;
  }
  .btn140 {
    min-width: 140px;
  }
  .transaction-detail-query {
    .el-form-item__label {
      display: block;
      float: inherit;
    }
  }
}

</style>
